import { TypedEvent } from '../../../core/typed_event';
import { AdobeAnalyticsData } from '../../../core/models/analytics/adobe_analytics_data';

export class MedicalConfirmAction {
  static readonly MEDICAL_CONFIRM_NO_EVENT = new TypedEvent<AdobeAnalyticsData>();
  static readonly MEDICAL_CONFIRM_YES_EVENT = new TypedEvent<AdobeAnalyticsData>();
  static init() {
    /// メディカル業種制御画面「はい」ボタン押下時
    document.getElementById('js-medical-confirm-yes-button')?.addEventListener('click', (e) => {
      const adobeAnalyticsData: AdobeAnalyticsData = {
        linkName: 'medicalFacilitiesConsentYes',
        target: e.target as HTMLElement
      };
      MedicalConfirmAction.MEDICAL_CONFIRM_YES_EVENT.trigger(adobeAnalyticsData);
    });

    /// メディカル業種制御画面「いいえ」ボタン押下時
    document.getElementById('js-medical-confirm-no-button')?.addEventListener('click', (e) => {
      const adobeAnalyticsData: AdobeAnalyticsData = {
        linkName: 'medicalFacilitiesConsentNo',
        target: e.target as HTMLElement
      };
      MedicalConfirmAction.MEDICAL_CONFIRM_NO_EVENT.trigger(adobeAnalyticsData);
    });
  }
}
